import { render, staticRenderFns } from "./survey-step-stroke-experience.vue?vue&type=template&id=5be84bf4"
import script from "./survey-step-stroke-experience.vue?vue&type=script&lang=js"
export * from "./survey-step-stroke-experience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports